import { Body, Box, Heading, IconButton } from '@hover/blueprint';
import type { BoxProps, ButtonProps } from '@hover/blueprint';
import { iUser } from '@hover/icons';
import React from 'react';

import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { HomeownerAppMenuNames } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import { Skeleton } from '../Skeleton';

export interface MobileHeaderProps extends BoxProps {
  headingText: string;
  iconSize?: ButtonProps['size'];
  isLoading: boolean;
  showHeaderText: boolean;
  showProfileIcon: boolean;
  showSubHeading: boolean;
  size?: ButtonProps['size'];
  subHeadingText?: string;
}

export const MobileHeader = ({
  headingText,
  iconSize,
  isLoading,
  showHeaderText,
  showProfileIcon,
  showSubHeading,
  size,
  subHeadingText,
  ...props
}: MobileHeaderProps) => {
  const { setCurrentMenu } = useHomeownerAppContext();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <Box flexDirection="column" {...props}>
      {showProfileIcon && (
        <Box
          as="header"
          display={{ tablet: 'none' }}
          pb={50}
          pt={600}
          px={500}
          width="100%"
          {...props}
        >
          <IconButton
            display={{ base: 'flex', tablet: 'none' }}
            icon={iUser}
            iconSize={iconSize}
            justifySelf="end"
            label={t('navbar.profile')}
            ml="auto"
            onClick={() => setCurrentMenu(HomeownerAppMenuNames.PROFILE)}
            size={size}
            variant="ghost"
          />
        </Box>
      )}
      <Box
        alignItems="start"
        display={{ tablet: showHeaderText ? 'flex' : 'none' }}
        flexDirection="column"
        gap={{ base: 200, tablet: 'unset' }}
        mt={{ base: 0, tablet: 100 }}
        mx={500}
        {...props}
      >
        <Skeleton isLoaded={!isLoading}>
          <Heading mb={0}>{headingText}</Heading>
        </Skeleton>

        {showSubHeading && !!subHeadingText && (
          <Skeleton isLoaded={!isLoading} mt={{ base: 100, tablet: 200 }}>
            <Body color="neutral.textLight" m={0}>
              {subHeadingText}
            </Body>
          </Skeleton>
        )}
      </Box>
    </Box>
  );
};
